<template>

  <div>
    <mu-row>
      <mu-col desktop="33" tablet="33" width="100"></mu-col>
      <mu-col desktop="33" tablet="33" width="100">

        <mu-card v-if="isVerifying" align="center">
          <mu-card-text align="center">
            {{$t('message.labelVerifyingAccount')}}
            <br/>
            <br/>
            <div>
              <mu-circular-progress :size="60"></mu-circular-progress>
            </div>
          </mu-card-text>
        </mu-card>

        <mu-card v-if="!isVerifying">
          <mu-card-text align="center">
            {{$t('message.labelAccountActivated')}}
          </mu-card-text>
          <mu-card-actions align="center">
            <mu-raised-button secondary :label="$t('message.labelContinueText')" @click.native="goToDashboard()"></mu-raised-button>
          </mu-card-actions>
        </mu-card>
      </mu-col>
      <mu-col desktop="33" tablet="33" width="100"></mu-col>
    </mu-row>
  </div>


</template>

<script>

  import AccountApi from '../../api/Account'
  import UserApi from '../../api/User'
  

  export default {
    data() {
      return {
        isVerifying: true
      }
    },
    mounted() {
      let self = this;
      if (_.has(self.$route.query, 'token')) {
        const token = self.$route.query.token;
        self.verify(token);
      }
      else {
        self.goToDashboard();
      }
    },
    methods: {
      verify(token) {
        let self = this;
        AccountApi.verifyAccountWithEmailToken(token).then(function () {
          UserApi.getUser().then(function (response) {
            self.$store.commit('setUser', response.data);
            self.isVerifying = false;
          })
        })
          .catch(function () {
            self.goToDashboard();
          })
      },
      goToDashboard() {
        let self = this;
        self.$router.push({
          name: 'Dashboard'
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EmailVerification.vue?deb15f16